import React, { useState } from 'react';
import { Row, Col, Container } from 'reactstrap';
import { useFormikContext } from 'formik';
import SupplierSelector from '../Form/SupplierSelector';
import RichTextEditor from '../Form/RichTextEditor';
import { useFetchEntity } from '../../Services/fetchApi';
import { endpoints } from '../../utils/Constants';
import { InsertPaths } from './InsertPaths';
import LoadingAnimation from '../Form/LoadingAnimation';
import { useEffect } from 'react';
import useFetch from '../../Services/useFetch';
import FormInput from '../Form/FormInput';




const EmailSuppliers = () => {
    const { setFieldValue, values } = useFormikContext();
    const [editor, setEditor] = useState();
    const [paths, loadingPaths, loadingError] = useFetchEntity({ name: 'Paths', getByStatus: () => endpoints.getAccessorsForEntity + 'CharterRequest' });
    const type = 'SupplierBidReminder';
    const [template, loadingTemplate, loadingErrorTemplate] = useFetch(endpoints.getTermsAndConditions + '/' + type)
    const insertSubject = (item) => {
        setFieldValue('subject', values.subject + '{' + item + '}');
    }
    useEffect(() => {
        if(template) {
            setFieldValue('message', template.terms);
            setFieldValue('subject', 'Please place a bid!');
        }
    }, [template, setFieldValue])
    const insertItem = (item) => {
        
        editor && editor.insertHTML('{' + item + '}');
        
    }
    return <Container>
        <Row>
            <Col >
                <SupplierSelector isMulti id='supplierIds' />
            </Col>
        </Row>
        <Row>
            {loadingPaths || loadingTemplate ? <LoadingAnimation height='15px' /> : null}
            {loadingError || loadingErrorTemplate ? <h6>Error loading paths</h6> : null}
          
            <Col>
                <FormInput id='subject' label='Subject' />
            </Col>
            { paths ? <InsertPaths parentPath={false} path={paths} insertItem={insertSubject} /> : null}
        </Row>
        <Row>
            <Col >
                {template ? <RichTextEditor setEditor={setEditor} id='message' label='Message' /> : null}
            </Col>
        </Row>

        <Row>
            <Col >
                {paths ? <InsertPaths parentPath={false} path={paths} insertItem={insertItem} /> : null}
            </Col>

        </Row>
    </Container>


}













export default EmailSuppliers;
